import React, { useEffect } from "react";
import PropTypes from "prop-types";
import EChallaneTrafficRules from "../../shared/e-challan-traffic-rules";
import PageNotFound from "../../shared/page-not-found";
import EChallanMetaTags from "../../shared/e-challan-meta-tags";
import styles from "./styles.css";
import EChallanHeroBannerV2 from "../state-e-challan-hero-banner";
import StateEChallanHowToCheck from "../state-e-challan-how-to-check";
import StateEChallanOnlinePayment from "../state-e-challan-online-payment";
import EChallanFaqsVariant from "../e-challan-faq-variant";
import StateEChallanBenefits from "../state-e-challan-benefits";
import StateEChallanComplaint from "../state-e-challan-complaint";
import StateEChallanTransaction from "../state-e-challan-transaction";
import EChallanRecentTransaction from "../e-challan-recent-transaction";
import useC2bCleverTap from "../../../hooks/use-c2b-clevertap";
import EChallanCities from "../e-challan-cities";
import { Breadcrumbs } from "@cars24/turbo-web/lib/breadcrumbs";
import { appUrl } from "../../../constants/url-constants";

const CityEChallan = ({
    stateName,
    history,
    isSSR = false,
    cmsContent = {},
    regNumberList,
    recentTransaction,
    isLoggedIn,
    secureToken,
    fetchRegNumberListConnect,
    fetchOrderDataConnect,
    isInvalidCity
}) => {
    useC2bCleverTap("Pay_challan");

    useEffect(() => {
        if (isLoggedIn) {
            if (!isSSR) {
                fetchRegNumberListConnect(secureToken);
            }
            if (!recentTransaction || !isSSR) {
                fetchOrderDataConnect(secureToken);
            }
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [isLoggedIn]);

    if (isInvalidCity) return <PageNotFound />;

    const {
        heroBannerData = {},
        seo = [],
        howToCheckChallanData = {},
        howToPayStateChallanData = {},
        trafficRules = {},
        eChallanComplaint = {},
        eChallanTransaction = {},
        challanBenefitsData = {},
        challanCitiesListData = {},
        challanFaqData = {},
        breadcrumb = []
    } = cmsContent || {};

    const {metaTitle = "", metaDescription = ""} = seo?.[0] || {};

    return (
        <React.Fragment>
            <EChallanMetaTags
                history={history}
                metaTitle={metaTitle}
                metaDescription={metaDescription}
            />
            <EChallanHeroBannerV2 heroBannerData={heroBannerData} regNumberList={regNumberList} isState />
            {!!recentTransaction && <EChallanRecentTransaction orderData={recentTransaction} />}
            <StateEChallanHowToCheck howToCheckChallanData={howToCheckChallanData} />
            <StateEChallanOnlinePayment howToPayStateChallanData={howToPayStateChallanData} />
            <EChallaneTrafficRules isDesktop stateName={stateName} trafficRules={trafficRules} />
            <StateEChallanComplaint eChallanComplaint={eChallanComplaint} />
            <StateEChallanTransaction eChallanTransaction={eChallanTransaction} />
            <StateEChallanBenefits challanBenefitsData={challanBenefitsData} />

            <div styleName={"styles.eChallanStates"}>
                <EChallanCities title={challanCitiesListData?.title} />
            </div>

            <EChallanFaqsVariant challanFaqData={challanFaqData} />

            <div styleName={"styles.breadCrumbsWrapper"}>
                <Breadcrumbs
                    attachSchema
                    baseUrl={appUrl()}
                    list={breadcrumb}
                />
            </div>
        </React.Fragment>
    );
};

CityEChallan.propTypes = {
    stateName: PropTypes.string,
    stateSlug: PropTypes.string,
    metaTitle: PropTypes.string,
    metaDescription: PropTypes.string,
    isInvalidState: PropTypes.bool,
    history: PropTypes.object,
    title: PropTypes.string,
    cmsContent: PropTypes.object,
    regNumberList: PropTypes.object,
    recentTransaction: PropTypes.object,
    isSSR: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    secureToken: PropTypes.string,
    fetchRegNumberListConnect: PropTypes.func,
    fetchOrderDataConnect: PropTypes.func,
    isInvalidCity: PropTypes.bool
};

export default CityEChallan;

